// S-92 ②: ページング全件取得のロジックは `@kawai/shared` の exportPaging に集約済み。
// 本ファイルは Firebase Callable の結線だけを持つ薄いラッパ（2 app で同一内容）。
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.js';
import {
  createCollectionAllPagesFetcher,
  type TenantExportInput,
  type TenantExportPageInput,
  type TenantExportPageResponse,
  type TenantExportResponse,
} from '@kawai/shared';

// ExportPage 等の既存呼び出し元互換のため、shared の公開物を再エクスポートする。
export {
  isExportAbortError,
  tenantExportErrorMessage,
  type CollectionAllPagesResult,
  type FetchCollectionAllPagesInput,
  type PartialCollectionInfo,
  type TenantExportInput,
  type TenantExportPageInput,
  type TenantExportPageResponse,
  type TenantExportResponse,
} from '@kawai/shared';

const tenantExportCallable = httpsCallable<TenantExportInput, TenantExportResponse>(
  functions,
  'tenantExportData',
);

/**
 * A-36 / S-57: `tenantExportData` Callable の薄いラッパ（全件モード）。
 * Functions 側で role 判定（tenant-admin は自テナントのみ / saas-admin は任意）と
 * tenantId スコープ強制を行い、失敗時は FunctionsError を throw する。
 */
export async function callTenantExport(
  input: TenantExportInput,
): Promise<TenantExportResponse> {
  const res = await tenantExportCallable(input);
  return res.data;
}

const tenantExportPageCallable = httpsCallable<
  TenantExportPageInput,
  TenantExportPageResponse
>(functions, 'tenantExportData');

/** S-84: コレクションを cursor ページングで 1 ページ取得する。 */
export async function callTenantExportPage(
  input: TenantExportPageInput,
): Promise<TenantExportPageResponse> {
  const res = await tenantExportPageCallable(input);
  return res.data;
}

/**
 * S-84 / S-88 / S-92: ページング全件取得。リトライ・予算・中断・時刻・非送出防御の
 * 実装とテストは `@kawai/shared` の exportPaging（Callable は本ファイルから注入）。
 */
export const fetchCollectionAllPages =
  createCollectionAllPagesFetcher(callTenantExportPage);
